var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$route.meta.hasBackground !== false)?_c('el-image',{staticClass:"main__background-img",attrs:{"src":require('@/assets/images/background-xl.jpg')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }